import {IsBoolean, IsDefined, IsNotEmpty, IsNumber, IsString, IsUUID} from "class-validator";
import {AutoMap} from "@automapper/classes";

export class StoreDto {
  @AutoMap()
  @IsUUID()
  @IsDefined()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsDefined()
  @IsNotEmpty()
  displayLabel: string;

  @IsNumber()
  availablePower: number;

  @IsString()
  batterySystem: string;

  @IsString()
  derType: string;

  @IsNumber()
  maxSoc: number;

  @IsNumber()
  soc: number;

  @IsNumber()
  power: number;

  @IsNumber()
  minSoc: number;

  @IsNumber()
  nameplateEnergy: number;

  @IsString()
  sid: string;

  @IsString()
  status: string;

  @IsNumber()
  stateOfHealth: number;

  @IsNumber()
  usableEnergy: number;

  @IsBoolean()
  available: boolean;
}
